module.exports = __webpack_public_path__ + "assets/img/18_1853_big.8df07fb0.jpg";